var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddcodeblock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20419_105945)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#909090",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8L13.5898 23.3802",
    stroke: "#909090",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.57 19.9457L24.6493 16L20.57 12.0543C20.1433 11.6416 20.1433 10.9654 20.57 10.5527C20.9873 10.1491 21.6572 10.1491 22.0745 10.5527L26.93 15.2492C27.3567 15.6619 27.3567 16.3381 26.93 16.7508L22.0745 21.4473C21.6572 21.8509 20.9873 21.8509 20.57 21.4473C20.1433 21.0346 20.1433 20.3584 20.57 19.9457Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0824 11.6949L6.63149 16L11.0824 20.3051C11.3059 20.5213 11.3059 20.8717 11.0824 21.0879C10.8589 21.304 10.4966 21.304 10.2731 21.0879L5.4176 16.3914C5.19413 16.1752 5.19413 15.8248 5.4176 15.6086L10.2731 10.9121C10.4966 10.696 10.8589 10.696 11.0824 10.9121C11.3059 11.1283 11.3059 11.4787 11.0824 11.6949Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63149 16L11.0824 20.3051C11.3059 20.5213 11.3059 20.8717 11.0824 21.0879C10.8589 21.304 10.4966 21.304 10.2731 21.0879L5.4176 16.3914C5.19413 16.1752 5.19413 15.8248 5.4176 15.6086L10.2731 10.9121C10.4966 10.696 10.8589 10.696 11.0824 10.9121C11.3059 11.1283 11.3059 11.4787 11.0824 11.6949L6.63149 16ZM7.35067 16L11.43 12.0543C11.8567 11.6416 11.8567 10.9654 11.43 10.5527C11.0127 10.1491 10.3428 10.1491 9.92551 10.5527L5.06998 15.2492C4.64334 15.6619 4.64334 16.3381 5.06998 16.7508L9.92551 21.4473C10.3428 21.8509 11.0127 21.8509 11.43 21.4473C11.8567 21.0346 11.8567 20.3584 11.43 19.9457L7.35067 16Z",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20419_105945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcodeblock);
export default __webpack_public_path__ + "static/media/addcodeblock.5f9c94bf.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddcodeblock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20419_105945)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#909090",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8L13.5898 23.3802",
    stroke: "#909090",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.57 19.9457L24.6493 16L20.57 12.0543C20.1433 11.6416 20.1433 10.9654 20.57 10.5527C20.9873 10.1491 21.6572 10.1491 22.0745 10.5527L26.93 15.2492C27.3567 15.6619 27.3567 16.3381 26.93 16.7508L22.0745 21.4473C21.6572 21.8509 20.9873 21.8509 20.57 21.4473C20.1433 21.0346 20.1433 20.3584 20.57 19.9457Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0824 11.6949L6.63149 16L11.0824 20.3051C11.3059 20.5213 11.3059 20.8717 11.0824 21.0879C10.8589 21.304 10.4966 21.304 10.2731 21.0879L5.4176 16.3914C5.19413 16.1752 5.19413 15.8248 5.4176 15.6086L10.2731 10.9121C10.4966 10.696 10.8589 10.696 11.0824 10.9121C11.3059 11.1283 11.3059 11.4787 11.0824 11.6949Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63149 16L11.0824 20.3051C11.3059 20.5213 11.3059 20.8717 11.0824 21.0879C10.8589 21.304 10.4966 21.304 10.2731 21.0879L5.4176 16.3914C5.19413 16.1752 5.19413 15.8248 5.4176 15.6086L10.2731 10.9121C10.4966 10.696 10.8589 10.696 11.0824 10.9121C11.3059 11.1283 11.3059 11.4787 11.0824 11.6949L6.63149 16ZM7.35067 16L11.43 12.0543C11.8567 11.6416 11.8567 10.9654 11.43 10.5527C11.0127 10.1491 10.3428 10.1491 9.92551 10.5527L5.06998 15.2492C4.64334 15.6619 4.64334 16.3381 5.06998 16.7508L9.92551 21.4473C10.3428 21.8509 11.0127 21.8509 11.43 21.4473C11.8567 21.0346 11.8567 20.3584 11.43 19.9457L7.35067 16Z",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20419_105945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcodeblock);
export default __webpack_public_path__ + "static/media/addcodeblock.5f9c94bf.svg";
export { ForwardRef as ReactComponent };